/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { ContentType } from 'client-code/actions';

import { Locale, LocaleKeys } from '../locale';

export class WatchNowTextFormatter {
    public static formatWatchText(
        seasonNumber?: number,
        episodeNumber?: number,
        firstAirDate?: string,
        contentType?: ContentType,
    ): string {
        if (seasonNumber !== undefined && episodeNumber !== undefined) {
            return `Watch S${seasonNumber} E${episodeNumber}`;
        }

        if (firstAirDate) {
            const formattedDate = this.formatDate(firstAirDate);
            const episodeType = this.getEpisodeType(contentType);
            return `Watch ${formattedDate} ${episodeType}`;
        }

        return Locale.getString(LocaleKeys.PS_OPTION_WATCH_NOW_DETAIL);
    }

    private static formatDate(dateString: string): string {
        try {
            const date = new Date(dateString);
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        } catch (error) {
            return '';
        }
    }

    private static getEpisodeType(contentType?: ContentType): string {
        if (!contentType) {
            return 'Episode';
        }

        switch (contentType) {
            case ContentType.Episode:
                return 'Episode';
            case ContentType.Movie:
                return 'Movie';
            case ContentType.Game:
                return 'Game';
            case ContentType.Match:
                return 'Match';
            case ContentType.Race:
                return 'Race';
            case ContentType.Event:
                return 'Event';
            case ContentType.Program:
                return 'Program';
            case ContentType.Meet:
                return 'Meet';
            default:
                return 'Show';
        }
    }
}
